
// Libraries
var React = require('react');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./FooterSponsors.scss');

class FooterSecondarySponsors extends React.Component {

	render() {
		return (		
			<div className={"FooterSponsors__secondary"}>
				{this.props.data.map((item, index) => {

					var element = null;
					if (item.link != null) {
						element = <a href={item.link.url} target={item.link.newWindow ? "_blank" : "_self"} rel={item.link.newWindow ? "noopener sponsored" : "sponsored"}  data-mparticle-track="sponsor_selected" data-mparticle-track-sponsor-name={ item.link.caption }> <img src={PlaceholderImg} data-src={item.image.smallUrl} alt={item.image.altText} /></a> 
					} else {
						element = <img src={PlaceholderImg} data-src={item.image.smallUrl} alt={item.image.altText} />
					}
					return(         
						<div className={"FooterSponsors__secondary__sponsor"} key={index}>
							{element}			
						</div>
					);
					
				})}
			</div>
		)
	}
}

module.exports = FooterSecondarySponsors;



// WEBPACK FOOTER //
// ./src/components/Footer/Sponsors/FooterSecondarySponsors.js